import React from "react";

import classNames from "classnames";

import styles from "./mText.module.css";

type ResponsiveSizeType = {
  base: MtextSizeType;
  sm?: MtextSizeType;
  md?: MtextSizeType;
  lg?: MtextSizeType;
  xl?: MtextSizeType;
};

type MtextSizeType = "hero" | "card" | "h1" | "h2" | "h3" | "h4" | "h5";

export type BreakpointsType = Record<keyof ResponsiveSizeType, MtextSizeType>;

type Props = {
  children: React.ReactNode;
  level?: ResponsiveSizeType | MtextSizeType;
  className?: string;
};

export function MHeading({ children, level = "h1", className }: Props) {
  const isResponsiveSize = typeof level === "object";

  const getSizeClassName = () => {
    if (!isResponsiveSize) return styles[level];

    const responsiveSizes = {
      sm: level.sm ?? level.md ?? level.lg ?? level.xl,
      md: level.md ?? level.lg ?? level.xl,
      lg: level.lg ?? level.xl,
      xl: level.xl,
      base: level.base,
    } satisfies Partial<BreakpointsType>;

    return classNames(
      Object.entries(responsiveSizes).reduce<string[]>(
        (acc, [breakpoint, size]) => {
          if (size) {
            acc.push(styles[`${breakpoint}_${size}`]);
          }

          return acc;
        },
        []
      )
    );
  };

  return (
    <div className={classNames(className, getSizeClassName())}>{children}</div>
  );
}
